import * as React from "react";
import { RouterProvider } from "react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { router } from "./routes/router";
import { queryClient, startQueryPersistence } from "./lib/query-client";
import { AuthProvider } from "./features/auth/auth-context";
import { Toaster } from "./components/ui/toaster";
import { UpdateAvailableToast } from "./components/update-available-toast";
import { OfflineIndicator } from "./components/offline-indicator";
import { startOutboxLoop } from "./lib/outbox";

export function App(): React.ReactElement {
  // Side-effects starten EINMAL bei app-mount. Beide sind idempotent gegen
  // re-runs (persistence schreibt last-write-wins, outbox-loop returnt
  // cleanup-fn die wir bei unmount aufrufen).
  React.useEffect(() => {
    startQueryPersistence();
    const stopOutbox = startOutboxLoop();

    // Storage-Persistenz (best-effort): verhindert browser-eviction (iOS 7d-policy).
    // Kein await — fire-and-forget, failure ist silent (user merkt nichts).
    if (navigator.storage?.persist) {
      void navigator.storage.persist();
    }

    return () => {
      stopOutbox();
    };
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <OfflineIndicator />
        <RouterProvider router={router} />
        <UpdateAvailableToast />
        <Toaster />
      </AuthProvider>
    </QueryClientProvider>
  );
}
